export const SuccessIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    height="24"
    width="24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 3a9 9 0 109 9 9.01 9.01 0 00-9-9zm3.951 7.413l-4.846 4.846a.692.692 0 01-.98 0L8.05 13.182a.693.693 0 11.98-.98l1.586 1.588 4.357-4.357a.693.693 0 01.98.98z"
      fill="currentColor"
    />
  </svg>
);
